import React, { useContext } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import Typography from '@mui/material/Typography';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import ResaurantDetails from './component/RestaurantDetails';
import { AuthContext } from '../../../context/AuthContext';


const Restaurant = () => {
  const { restaurantid } = useContext(AuthContext);
  return (
    <div>
      <Breadcrumbs
        style={{ marginLeft: '40px', marginBottom: '15px' }}
        aria-label="breadcrumb"
      >
        <Typography sx={{ color: 'text.primary' }}>Restaurant</Typography>
        <Typography sx={{ color: 'text.primary' }}>Restaurant Profile</Typography>
      </Breadcrumbs>
      <Container>
        <Row>
          <ResaurantDetails 
            restaurantid={restaurantid}
          />
        </Row>
      </Container>
    </div>

  );
};
export default Restaurant;
